<template>
  <div class="ai-tool-layout-content" :class="mode">
    <div class="content-header">
      <div class="content-header_left">
        <el-button v-show="inputMode.includes('file')" class="big-content-btn" size="small" type="primary" @click="openFile">
          <i class="iconfont">&#xe62f;</i>
          <span class="btn-text">本地上传</span>
        </el-button>
        <el-button v-show="inputMode.includes('resource')" style="margin-right:20px;" class="big-content-btn" size="small" type="primary" plain @click="showResource">
          <i class="iconfont">&#xe754;</i>
          <span class="btn-text">素材库上传</span>
        </el-button>
        <span>保存位置： {{ getShoreName(saveFolderName) }}</span>
        <el-button style="margin-left: 10px;" size="small" @click="addFolder">修改</el-button>
      </div>
      <div class="content-header_right">
        <slot name="identify-header-right" />
        <!-- 智能处理 -->
        <template v-if="aiType === 'image_colorize'">
          <el-dropdown trigger="click" :disabled="!(isSuccess)">
            <span class="el-dropdown-link">
              <img class="aiImg" :src="aiImg">智能处理
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :disabled="!(isSuccess)" @click.native="remoteAiUse('image_enhancement')">图片智能清晰</el-dropdown-item>
              <el-dropdown-item :disabled="!(isSuccess)" @click.native="remoteAiUse('image_enlargement')">图片智能放大</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
        <el-button
          size="small"
          @click="goServiceManage">服务管理</el-button>
        <el-button v-show="outputMode.includes('file')" :disabled="!(isSuccess)" size="small" @click="downloadImg">下载图片</el-button>
        <el-button :loading="useCustomLoading" v-if="outputMode.includes('singleEditor') && isSuccess" :disabled="!(isSuccess)" type="primary" size="small"
          @click="useCustom">{{ aiType === 'image_slim' ? '替换' : '应用' }}</el-button>
        <el-button :loading="useCustomLoading" v-if="outputMode.includes('multiEditor')" 
          type="primary" size="small"
          @click="useCustomMulti">批量替换</el-button>
        <el-button v-if="outputMode.includes('insert') &&isSuccess" 
          type="primary" size="small"
          @click="insertMethod">插入</el-button>
        <el-button v-if="outputMode.includes('multiEditor')" 
          :disabled="!(canIdentify || status === 'wait')" type="primary" size="small"
          @click="startIdentifyCustom">开始处理</el-button>
        <el-button v-else :disabled="!(canIdentify || status === 'wait')" size="small" type="primary"
        @click="startIdentify">开始处理</el-button>
      </div>
    </div>
    <localFileUploader ref="localFileUploader" :useCustomUpload="aiType === 'image_slim'" @addResource="addResource" />
    <slot name="identify-content" />
    <el-dialog
      title="保存位置"
      :append-to-body="true"
      :visible.sync="dialogFolderVisible"
      width="600px"
      :before-close="cancelFolder"
    >
      <div class="dialogTree">
        <folderTree
          ref="MugedaAiFolderTree"
        />
      </div>
      <div  style="text-align: right; margin: 10px 0 0 0">
        <el-button size="small" class="class-cancel" @click="cancelFolder()">
          取消
        </el-button>
        <el-button size="small" type="primary" @click="confirmFolder()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import localFileUploader from './components/localFileUploader.vue'
import folderTree from './components/folderTree.vue'
import { useInitResource, useShowResource, useDestroyResource } from '@/hooks/useResource';
import { useGetIdentifyInfo } from '@/hooks/useIdentifyInfo';
import aiImg from '/imgs/AI图标.png';

import { getIdentifyInfo } from "@/api/common"

/* status 
  wait: 待处理
  ing: 处理中  
  success 处理完成 
  error 服务使用超限  
*/
export default {
  name: 'AiLayout',
  components: {
    localFileUploader,
    folderTree,
  },
  inject: ['resourceData'],
  props: {
    aiType: {
      type: String,
      required: true,
    },
    inputMode: {
      type: Array,
      default: () => ['file', 'resource'],
    },
    outputMode: {
      type: Array,
      default: () => ['file'],
    },
    mode: {
      type: String,
    },
    status: {
      type: String,
      required: true,
    },
    canIdentify: {
      type: Boolean,
      default: false
    },
    haveSuccess: {
      type: Boolean,
      default: false
    },
    styles: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      identifyInfo: {},
      dialogFolderVisible: false,
      saveFolderId: '',
      saveFolderName: '默认文件夹',
      dialogResourceVisible: true,
      useResource: null,
      useCustomLoading: false,
      aiImg,
    }
  },
  computed: {
    isSuccess() {
      return this.status === 'success' || this.haveSuccess
    },
  },
  created() {
    
  },
  async mounted() {
    this.identifyInfo = await useGetIdentifyInfo(this.aiType, getIdentifyInfo, this)
    this.$emit('emitAccountInfo', this.identifyInfo)
    setTimeout(()=>{
      this.useResource = useInitResource({
        mode: this.mode
      }, this.addResource);
    }, 500)
  },
  methods: {
    showResource() {
      useShowResource(this.useResource)
    },
    cancelFolder() {
      this.dialogFolderVisible = false
    },
    addFolder() {
      this.dialogFolderVisible = true
      this.$nextTick(()=>{

        this.$refs.MugedaAiFolderTree.getAllFolders()
      })
    },
    confirmFolder() {
      const node = this.$refs.MugedaAiFolderTree.$refs.tree.getCurrentNode()
      if (!node) {
        this.$message({
          type: 'error',
          message: '请选择文件夹',
        })
        return
      }
      this.saveFolderName = node.label
      this.saveFolderId = node.id
      this.cancelFolder()
    },
    openFile(canMultiple) {
      this.$refs.localFileUploader.openFile(canMultiple)
    },
    useCustom() {
      this.useCustomLoading = true
      this.$emit('useCustom')
    },
    downloadImg() {
      this.$emit('downloadImg')
    },
    checkResource(resource) {
      if (resource.length) {
        if( resource.length > (1024 * 1024 * 10)) {
          this.$message({
            type: 'error',
            message: '文件大小不符合：最大支持10MB文件',
          })
          return false
        } 
      } else {
        this.$message({
          type: 'error',
          message: '文件属性缺失',
        })
        return false
      }
      if (resource.content_type || (resource.file && resource.file.type)) {
        const _resType = resource.content_type || resource.file.type
        if (!['image/jpeg', 'image/png', 'image/gif'].includes(_resType)) {
          this.$message({
            type: 'error',
            message: '类型不符合：仅支持PNG、JPEG、GIF图片',
          })
          return false
        }
      } else {
        this.$message({
          type: 'error',
          message: '文件属性缺失',
        })
        return false
      }
      return true
    },
    addResource(resources) {
      if (Array.isArray(resources)) {
        const _checkedList = []
        resources.forEach(element => {
          if (this.checkResource(element)) {
            _checkedList.push(element)
          }
        })
        if (_checkedList.length > 0) {
          this.$emit('addResourceData', _checkedList)
        }
      } else {
        const checked = this.checkResource(resources)
        if (checked) {
          this.$emit('addResourceData', resources)
        }
      }
    },
    resetResource() {
      this.status = 'wait'
      this.$forceUpdate()
    },
    handleDrop(event) {
      event.preventDefault()
      const files = event.dataTransfer.files;
      for (let i = 0; i < files.length; i++) {
        if (files[i].type.startsWith('image/')) {
          this.$refs.localFileUploader.fileLoad(files[i])
        }
      }
    },
    startIdentify() {
      this.$emit('startIdentify')
    },
    startIdentifyCustom() {
      this.$emit('startIdentifyCustom')
    },
    useCustomMulti() {
      this.useCustomLoading = true
      this.$emit('useCustomMulti')
    },
    insertMethod() {
      this.$emit('insertMethod')
    },
    goServiceManage() {
      window.open('/rm/team/service')
    },
    stopBtnLoading() {
      this.useCustomLoading = false
    },
    getShoreName(name) {
      if (name.length > 5) {
        return name.substr(0, 5) + '...'
      } else {
        return name
      }
    },
    remoteAiUse(type){
      // 依赖外部实现其他组件的调用
      this.$emit('remoteAiUse', type)
    },
  },
  beforeDestroy() {
    useDestroyResource(this.useResource)
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-message-box {
  width: 600px;
}
::v-deep .el-dropdown  {
  vertical-align: bottom;
  margin-right: 10px;
  .el-dropdown-link {
    cursor: pointer;
    position: relative;
    bottom: 8px;
    font-size: 14px;
    .aiImg {
      position: relative;
      top: 10px;
    }
  }
}
.ai-tool-layout-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  font-size: 14px;
  color: #666666;
  height: 100%;
  .content-header {
    margin: 0 0 10px 0;
    display: flex;
    justify-content: space-between;
    .content-header_left {
      display: flex;
      align-items: center;
      ::v-deep .big-content-btn {
        padding: 7px 15px;
        span {
          display: flex;
          align-items: center;
        }
        .iconfont {
          font-size: 20px;
          margin-right: 3px;
        }
        .btn-text {
        }
      }
    }
  }
}

.h5 {
  .ai-tool-layout-content {
   color: #CCCCCC !important;
  }
}
</style>